import React from 'react';
import { BrowserRouter, Route, Switch } from "react-router-dom";



import 'primereact/resources/themes/nova-light/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';

import Bienvenido from './componentes/app/Bienvenido.jsx';
import Login from './componentes/login/Login.jsx';
//import FacturacionSinRegistro from './componentes/app/FacturacionSinRegistro';
import {FacturacionSinRegistro} from './componentes/app/facturaciontickets/FacturacionSinRegistro';



function App() {
  return (
   
    <BrowserRouter>
      <Switch>
        <Route path="/facturacionbanobras" component={Login} exact/>
        <Route path="/facturacionbanobras/bienvenido" component={Bienvenido} />
        <Route path="/facturacionbanobras/facturacion-sin-registro" component={FacturacionSinRegistro}/>
      </Switch>
    </BrowserRouter>
  );
}

export default App;
